export default import.meta.ROLLDOWN_FILE_URL_gt5RfhIhL3AvztJj7_xaRA